import styled from 'styled-components';
import media from '../../../styles/Media.styled';
import { ENVIRONMENTVARIABLE } from '../../../constants/appConstants';
import { PRIMARY_FONT_COLOR, BASE_TEXT_PX,CURSOR } from '../../../styles/fonts/MCFontConstants';

export const PopupTitle = styled.div`
    color: ${({ color }) => (color ? color : PRIMARY_FONT_COLOR)};
    opacity: 1;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : BASE_TEXT_PX)};
    ${media.mobileDevice` 
      justify-content: ${({ mbJustifyContent }) => (mbJustifyContent ? mbJustifyContent : '')};   
    `};
`;

export const Title = styled.div`
    text-align: ${({ textAlign }) => (textAlign ? textAlign : '')};
    font-size: ${({ DeskFontSize }) => (DeskFontSize ? DeskFontSize : BASE_TEXT_PX)};
    color: ${({ color }) => (color ? color : PRIMARY_FONT_COLOR)};
    ${media.mobileDevice`    
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '')};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '')};
    width: ${({ width }) => (width ? width : '#130e4a')};
    `};
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '')};
`;
export const Icon = styled.div`
    border: 1px solid #ffffff;
    opacity: 1;
    background: transparent url(${({ mobilePath }) => mobilePath}) 0% 0%
        no-repeat padding-box;
    width: ${({ iconWidth }) => (iconWidth ? iconWidth : '22px')};
    height: 23px;
    margin-top: 1px;
    display: ${({ hideIcon }) => (hideIcon ? 'none' : '')};
    cursor: ${CURSOR};
    ${media.mobileDevice`
    width: ${({ mbIconWidth }) => (mbIconWidth ? mbIconWidth : '29px')};
    margin-left : ${({ mbIconMarginLeft }) => ( mbIconMarginLeft ? mbIconMarginLeft : '')};
   

    `}
      @media only screen and (min-width: 390px) and (max-width: 395px) {
         margin-right : ${({ mbIconMarginRight }) => ( mbIconMarginRight ? mbIconMarginRight : '')};
    }
   
    
`;

export const PopupContent = styled.div`
    position: ${({ position }) => (position ? position : 'relative')};
    margin: ${({ margin }) => (margin ? '15px' : '0 auto')};
    height:${({ contentHeight }) => (contentHeight ? contentHeight : '')};
    width: ${({ contentWidth, emptyCartWidth }) =>
        emptyCartWidth ? emptyCartWidth : contentWidth && '770px'};
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: ${({ borderRadius }) =>
        borderRadius ? borderRadius : '12px'};
    padding: ${({ popupContentPadding }) =>
        popupContentPadding ? popupContentPadding : '15px 20px'};
    border: 1px solid #999;
    display: flex;
    display: -webkit-flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'column'};
    overflow-y: ${({ addProductSpecific }) =>
        addProductSpecific ? 'scroll' : ''};
    max-height: ${({ addProductSpecific }) =>
        addProductSpecific ? '500px' : ''};
    overscroll-behavior: contain;

      @media only screen and (min-width: 390px) and (max-width: 395px) {
        height: ${({ popHeight }) =>
            popHeight === '40%' ? '35%' : popHeight === '38%'?'33%': popHeight === '45%'?'35%':popHeight === '43%'?'33%':popHeight};
    }
    @media only screen and (min-width: 430px) and (max-width: 435px) {
        height: ${({ popHeight }) =>
            popHeight === '40%' ? '30%' : popHeight === '38%'?'28%':popHeight === '38%'?'33%': popHeight === '45%'?'33%':popHeight === '43%'?'30%':popHeight};
    }
    @media only screen and (min-device-width: 667px) and (max-device-width: 1023px) and (orientation: landscape) {
    margin-top: ${({ landscapeMarginTop }) => landscapeMarginTop};
    }

    ${media.exSmallDevice`
        margin-top :  ${({ popHeight }) => popHeight && '109px !important'} ;
    `}

    @media only screen and (min-device-width: 300px) and (max-device-width: 450px) and (orientation : landscape) {
        height: ${({ mbLandscapeHeight }) => mbLandscapeHeight};
    }

    @media only screen and (min-device-width: 667px) and (max-device-width: 1023px) and (orientation : landscape) {
        width: ${({ ipadwidth }) => ipadwidth};
        height: ${({ landscapeHeight }) => landscapeHeight};
        margin-bottom: ${({ landscapeMarginBottom }) => landscapeMarginBottom};
    }
    @media only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (orientation: portrait) {
        width: ${({ portraitWidth }) => portraitWidth};
    }

    @media only screen and (min-width: 577px) and (max-width: 860px) {
        width: ${({ contentWidth, emptyCartWidth, ipadwidth, portraitWidth }) =>
            emptyCartWidth ? emptyCartWidth : ipadwidth ? ipadwidth : portraitWidth ? portraitWidth : contentWidth ? '85%' : ''};
    }
    
    ${media.smalDevice`
        margin-left : ${({ SignatureMargin }) => SignatureMargin && '40px'};
        margin-right : ${({ SignatureMargin }) => SignatureMargin && '40px'};
        max-height: ${({ contentTabHeight, isFromPop }) =>
            !isFromPop && contentTabHeight && 'max-content'};  
        height :   ${({ contentTabHeight, shipAdressPopup, smalHeight }) =>
            (contentTabHeight && shipAdressPopup) || smalHeight
                ? '90%'
                : contentTabHeight && !shipAdressPopup && '102%'} ;
        margin-top :  ${({ contentTabHeight }) => contentTabHeight && '120px'} ;
        padding-bottom:${({ paddingBottom, shipAdressPopup }) =>
            shipAdressPopup &&
            (ENVIRONMENTVARIABLE
                ? `max(${
                      paddingBottom ? paddingBottom : '3vh'
                  },calc(4*env(safe-area-inset-bottom)))`
                : paddingBottom
                ? paddingBottom
                : '10vh')};
        background: ${({ backgroundColor }) =>
            backgroundColor && '#f5f5f5 0% 0% no-repeat padding-box'};
        width: ${({ mobileWidthB33Popup }) => mobileWidthB33Popup};
        flex-direction: ${({ flexDirection }) =>
            flexDirection ? flexDirection : ''};
    `}

    ${media.mobileDevice`
        width: ${({ mobileWidth, mobileWidthPercent ,mobileWidthB33Popup}) =>
           mobileWidthB33Popup?mobileWidthB33Popup: mobileWidth
                ? '100%'
                : mobileWidthPercent
                ? mobileWidthPercent
                : ''};
        padding: ${({ popupContentPaddingMobile }) =>
            popupContentPaddingMobile};
        max-height: ${({ popHeight, isFromPop ,isEmptyCart}) =>
            !isFromPop && popHeight&&!isEmptyCart && 'max-content'}; 
        height :   ${({ popHeight, mobHeight }) =>
            popHeight || (mobHeight && '102% !important')} ;
        margin-top :  ${({ popHeight }) => popHeight && '145px !important'} ;
        margin-left :  ${({ popHeight }) => popHeight && 'auto !important'} ;
        margin-right :${({ popHeight }) => popHeight && 'auto !important'} ;
        border-top-left-radius: ${({ borderTopLeftRadius }) =>
            borderTopLeftRadius};
        border-top-right-radius: ${({ borderTopRightRadius }) =>
            borderTopRightRadius};
        min-height: ${({ minHeight }) => minHeight};
        margin: ${({ mobileMargin }) => mobileMargin};
        top: ${({ top }) => top};
        background: ${({ mobileBg }) => mobileBg};
        overflow-y: ${({ mbOverflowY }) => mbOverflowY};
       // border-radius: 1px;

    `}
`;

export const PopupContainer = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ background }) =>
        background ? background : ' #000000cc 0% 0% no-repeat padding-box'};
    width: 100%;
    height: ${({ hasBanner, isLandscape }) =>
        hasBanner && isLandscape ? '120vh' : '100vh'};
    top: 0;
    left: 0;
    opacity: ${({ opacity }) => (opacity ? opacity : '1')};
    z-index: ${({ zIndex, isUnsavedPage }) => zIndex ? zIndex : (isUnsavedPage ? 10000000 : 100000)};
    overflow: ${({ overflow }) => overflow};

    ${media.smalDevice`

    background :  ${({ background, contentTabHeight }) =>
        background
            ? background
            : contentTabHeight
            ? '0% 0% no-repeat padding-box !important'
            : '#000000cc 0% 0% no-repeat padding-box'} ;
    z-index: ${({ mobileZIndex, zIndex, isUnsavedPage }) =>
        mobileZIndex !== undefined &&
        mobileZIndex !== null &&
        `${mobileZIndex}` !== ''
            ? mobileZIndex
            : zIndex ? zIndex : (isUnsavedPage ? 10000000 : 100000)} !important;
    `}
    ${media.mobileDevice`
    background :  ${({ background, popHeight, mbBackGround, isFromPop }) =>
        background
            ? background
            : popHeight && !isFromPop
            ? '0% 0% no-repeat padding-box !important'
            : mbBackGround
            ? 'rgb(0 0 0 / 0%) 0% 0% no-repeat padding-box'
            : '#000000cc 0% 0% no-repeat padding-box'} ;            
    z-index: ${({ mobileZIndex, zIndex, isUnsavedPage }) =>
        mobileZIndex !== undefined &&
        mobileZIndex !== null &&
        `${mobileZIndex}` !== ''
            ? mobileZIndex
            : zIndex ? zIndex : (isUnsavedPage ? 10000000 : 100000)};
    
    
    `}
    @media only screen and (orientation: landscape) and (max-height: 500px) {
        height: 100vh;
        overflow-y: ${({ allowLandscapeScroll }) => (allowLandscapeScroll ? 'auto' : 'hidden')};
        align-items: flex-start;
        padding-top: ${({ mbPaddingTop }) => (mbPaddingTop ? mbPaddingTop : '80px')};
        padding-bottom: 20px;
        box-sizing: border-box;
        z-index: ${({ mobileZIndex, zIndex, isUnsavedPage }) =>
            mobileZIndex !== undefined &&
            mobileZIndex !== null &&
            `${mobileZIndex}` !== ''
                ? mobileZIndex
                : zIndex ? zIndex : (isUnsavedPage ? 10000000 : 100000)} !important;
        position: fixed !important;
    }
`;

export const Merge = styled.div`
    display: flex;
    flex-direction: row;
    width: ${({ webWidth }) => (webWidth ? webWidth : '')};
    height: ${({ webHeight }) => (webHeight ? webHeight : '')};
    ${media.mobileDevice`
    width: ${({ width }) => (width ? width : '')};
    align-items:${({ alignItemsMob }) =>
        alignItemsMob ? alignItemsMob : 'center'} ;
    margin-right:${({ mbMarginRight }) =>
        mbMarginRight ? mbMarginRight : ''} ;
    justify-content: ${({ mbJustifyContent }) =>
        mbJustifyContent ? mbJustifyContent : ''} ;
    `}
`;

export const PopUpImage = styled.img.attrs((props) => ({
    src: props.img,
}))`
    width: ${({ width }) => (width ? width : '30px')};
    height: ${({ height }) => (height ? height : '27px')};
    padding-right: ${({ paddingRight }) =>
        paddingRight ? paddingRight : '5px'};
    padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : '2px')};
    margin-left: ${({ marginLeftDesktop }) =>
        marginLeftDesktop ? marginLeftDesktop : ''};
    align-self: flex-start; /* Aligns the icon to the top of the div */
    ${media.mobileDevice`
        margin-left: ${({ marginLeftMobile }) =>
            marginLeftMobile ? marginLeftMobile : ''};
        margin-top : ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    `}
`;

export const BackTitle = styled.p`
    color: ${({ color }) => (color ? color : PRIMARY_FONT_COLOR)};
    font-family: 'AvenirNextWorld Regular';
    padding: 0;
    margin: 0;
    display: flex;
    cursor: pointer;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '1px')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : BASE_TEXT_PX)};
    ${media.mobileDevice`
        margin: 0px 0 10px -7px;
        font-size: ${({ fontSize }) => (fontSize ? fontSize : BASE_TEXT_PX)};
    `}
`;
